import {Component} from 'react';
import PropTypes from 'prop-types';
import EditableTitle from './EditableTitle';
import {Form, Header, Segment} from 'semantic-ui-react';

export default class CustomiseFloorPlanSection extends Component {
  static propTypes = {
    section: PropTypes.object.isRequired,
    reportType: PropTypes.string.isRequired,
    updatePreferences: PropTypes.func.isRequired,
    updateSectionValue: PropTypes.func.isRequired,
  };

  updateReportTitle = (data) => {
    const {reportType, updateSectionValue, updatePreferences} = this.props;
    updateSectionValue(data.title, 'title', reportType);
    updatePreferences({'floorPlan.sectionData.title': data.title}, reportType);
  };

  render() {
    const {section} = this.props;
    return (
      <div className="floor-plan-section">
        <Header as="h2" className="section-type" style={{fontWeight: 'bold'}} disabled>Floor Plan</Header>
        <Segment style={{padding: '30px'}}>
          <Header as="h3" disabled>Title</Header>
          <Form className="sectionData">
            <Form.Group inline>
              <EditableTitle
                onUpdateData={this.updateReportTitle}
                title={section.sectionData.title}
                isEnabled={true}
                maxLength={32}
                width="50%"/>
            </Form.Group>
          </Form>
          {/*<PdfReport loading={loading} maxPages={1} url={url} width={200}/>*/}
          <div className="floor-plan-photos">
            {section.sectionData.floorPlanUris && section.sectionData.floorPlanUris.map(uri => (
              <img src={uri} key={uri} alt="floor plan"/>
            ))}
          </div>
        </Segment>
      </div>
    );
  }
}